import {
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import React, { useEffect } from "react";
import { ClearRounded } from "@mui/icons-material";
import InputSelectItem from "./InputFields/InputSelectItem";
import { formatDecimal, useFormatPrice } from "../../../../hooks/Method";
import { no_img } from "../../../../assets";
import InputReturnQty from "./InputFields/InputReturnQty";
import TableProdWidget from "./InputFields/TableProdWidget";
import InputPrice from "./InputFields/InputPrice";
import InputReason from "./InputFields/InputReason";

const ReturnItems = ({ values, setValues, stockDetails }) => {
  const formatPrice = useFormatPrice();

  const handleInpChg = (param) => {
    setValues((j) => ({
      ...j,
      stockReturnItems: j.stockReturnItems.map((k) =>
        k.key === param.key ? { ...k, [param.name]: param.value } : k
      ),
    }));
  };

  useEffect(() => {
    const totalQty = values.stockReturnItems.reduce(
      (acc, item) => acc + parseFloat(item.qty || 0),
      0
    );

    const totalCost = values.stockReturnItems.reduce(
      (acc, item) =>
        acc + parseFloat(item.unitPrice || 0) * parseFloat(item.qty || 0),
      0
    );

    setValues((j) => ({
      ...j,
      totalQty: totalQty,
      totalAmount: totalCost,
    }));
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.stockReturnItems]);

  return (
    <>
      <Grid item xs={12}>
        <div className="flex flex-col md:flex-row items-start md:items-center gap-2 md:gap-7 mt-3">
          <div className="w-auto md:flex-shrink-0">
            <span className="text-gray-600 uppercase font-bold border-left tracking-wider">
              Add Return Products
            </span>
          </div>
          <div className="w-full">
            <InputSelectItem {...{ stockDetails, values, setValues }} />
          </div>
        </div>
      </Grid>
      <Grid item xs={12}>
        <TableContainer className="border rounded-[12px]">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Product</TableCell>
                <TableCell>Return Reason</TableCell>
                <TableCell sx={{ minWidth: "160px" }}>Quantity</TableCell>
                <TableCell sx={{ minWidth: "160px" }}>Cost Price</TableCell>
                <TableCell sx={{ minWidth: "160px" }}>Total Cost</TableCell>
                <TableCell align="right"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {values.stockReturnItems &&
                values.stockReturnItems.map((item, i) => {
                  var imgUrl = "";
                  if (item.isVariant) imgUrl = item.varProd?.imgs[0] || no_img;
                  else imgUrl = item.prod?.imgs[0] || no_img;
                  return (
                    <TableRow hover key={i}>
                      <TableCell>
                        <TableProdWidget {...{ imgUrl, item }} />
                      </TableCell>
                      <TableCell>
                        <InputReason {...{ handleInpChg, item }} />
                      </TableCell>
                      <TableCell>
                        <InputReturnQty {...{ item, handleInpChg }} />
                      </TableCell>
                      <TableCell>
                        <InputPrice {...{ item, handleInpChg }} />
                      </TableCell>
                      <TableCell>
                        <span
                          className="text-gray-500 font-medium text-[16px]"
                          style={{ minWidth: "120px" }}
                        >
                          {formatPrice(
                            parseFloat(item.unitPrice) * parseFloat(item.qty),
                            true
                          )}
                        </span>
                      </TableCell>
                      <TableCell align="right">
                        <Tooltip title="Delete this variants">
                          <IconButton color="error" size="small">
                            <ClearRounded className="!text-[20px]" />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  );
                })}
              <TableRow>
                <TableCell sx={{ border: 0 }}></TableCell>
                <TableCell sx={{ border: 0 }}>
                  <span className="text-[14px] font-semibold text-gray-500 uppercase tracking-wider">
                    Total Qty:
                  </span>
                </TableCell>
                <TableCell sx={{ border: 0 }}>
                  <span className="!text-[16px] !font-semibold text-gray-500 uppercase">
                    {formatDecimal(values.totalQty, true)}
                  </span>
                </TableCell>
                <TableCell sx={{ border: 0 }}>
                  <span className="text-[16px] font-semibold text-gray-500 uppercase tracking-wider">
                    Total Amount:
                  </span>
                </TableCell>
                <TableCell sx={{ border: 0 }}>
                  <span className="!text-[18px] !font-semibold text-gray-500 uppercase">
                    {formatPrice(values.totalAmount)}
                  </span>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </>
  );
};

export default ReturnItems;
